import { render, staticRenderFns } from "./ChallengeCompletionDate.vue?vue&type=template&id=52697294&scoped=true&lang=pug&"
import script from "./ChallengeCompletionDate.vue?vue&type=script&lang=js&"
export * from "./ChallengeCompletionDate.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeCompletionDate.vue?vue&type=style&index=0&id=52697294&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52697294",
  null
  
)

export default component.exports